const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGreenEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1894_12464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.086 24.8627C54.5985 12.3957 43.6104 3 30.4266 3C20.2979 3 11.4601 8.54919 6.78333 16.7805",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2973,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83838 35.5527C6.32595 48.0198 17.3141 57.4154 30.4978 57.4154C40.753 57.4154 49.6784 51.73 54.3097 43.3365",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2973,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.85 8.19625C21.2089 10.7487 21.5235 14.1865 19.5094 16.9141C17.0348 20.2644 10.9116 21.6881 7.4705 24.0881C4.92131 25.8654 3.36131 29.7638 3.36131 29.7638C3.36131 29.7638 -2.82031 17.313 4.82077 8.21571C7.66509 4.83301 12.9159 3.15301 16.824 5.20922L18.0727 5.96814",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2973,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0555 52.4339C39.0047 50.1312 38.8555 46.836 40.9247 44.4003C44.3982 40.3139 48.8674 40.1355 52.4252 38.4587C56.1679 36.6912 57.715 31.6836 57.715 31.6836C57.715 31.6836 63.3485 44.1928 55.6587 53.2285C52.7852 56.6014 47.7323 58.3431 43.0815 56.5106C42.3452 56.2187 41.5863 55.5766 41.2036 55.2263",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2973,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2296 27.2439H33.0372L34.3312 12.3672L19.6977 33.1693H27.8901L26.5961 48.0429L41.2296 27.2439Z",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2973,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1894_12464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenEnergy);
export default __webpack_public_path__ + "static/media/icon-green-energy.bb5eeb2c0e61bbe9ecfb02876e63b22a.svg";
export { ForwardRef as ReactComponent };